// extracted by mini-css-extract-plugin
module.exports = {"title":"AddNewUserRelationshipModal_title__FmYGu","divider":"AddNewUserRelationshipModal_divider__1Vlc_"};